import getUrl from '@/routes/routes/helpers/getUrl';
import {
  formatDateLong,
  formatDateTime,
  formatPrice,
} from '../../utils/formats';

/**
 *
 * Race detail resolver.
 * This pure function annotates race detail objects with computed values, e.g. formatted strings.
 */
const resolver = (race) => {
  return (
    race && {
      ...race,
      ...(race.eventDetails && {
        // Race page no longer exists, use event page
        canonical: `${WEB_ROOT}${getUrl.eventPage(
          race.country,
          race.eventDetails.slug,
          race.eventDetails.id,
        )}`,
        eventDetails: {
          ...race.eventDetails,
          // Construct event site link for router
          permalink: `${getUrl.eventPage(
            race.country,
            race.eventDetails.slug,
            race.eventDetails.id,
          )}`,
        },
      }),
      // Start date is optional
      ...(race.startDate && {
        startDateFormatted: formatDateLong(race.startDate),
      }),
      ...(race.startTime && {
        startTimeFormatted: formatDateTime(race.startDate),
      }),
      // Tickets are optional
      ...(race.tickets && {
        tickets: {
          ...race.tickets,
          // Format from price
          pricesFromFormatted: formatPrice(
            race.tickets.currencyLabel,
            race.tickets.pricesFrom,
          ),
          // Format to price, optional (number)
          ...(typeof race.tickets.pricesTo !== 'undefined' && {
            pricesToFormatted: formatPrice(
              race.tickets.currencyLabel,
              race.tickets.pricesTo,
            ),
          }),
          // Tickets are optional
          ...(race.tickets.tickets && {
            tickets: race.tickets.tickets
              .map((ticket) => ({
                ...ticket,
                // Availability is optional
                ...(ticket.availability && {
                  availability: {
                    ...ticket.availability,
                    // Format from date, optional
                    ...(ticket.availability.from && {
                      fromFormatted: formatDateLong(ticket.availability.from),
                    }),
                    // Format from date, optional
                    ...(ticket.availability.to && {
                      toFormatted: formatDateLong(ticket.availability.to),
                    }),
                  },
                }),
                bookingUrl: ticket.bookingUrl,
                rrpFormatted: formatPrice(
                  race.tickets.currencyLabel,
                  ticket.rrp,
                ),
                // Format discount price, optional (number)
                ...(typeof ticket.discountPrice === 'number' && {
                  discountPriceFormatted: formatPrice(
                    race.tickets.currencyLabel,
                    ticket.discountPrice,
                  ),
                }),
              }))
              .filter((t) => t && !t.isDeleted),
          }),
        },
      }),
    }
  );
};

export default resolver;
